// Module
var code = "<p>[# summary]</p> <h3 id=\"актив-symbol\">Актив {symbol}</h3> <p>{description}</p> <p>Выпущен: {issuer}</p> <p>Доллар США (знак: $; символ: USD) является официальной валютой Соединенных Штатов Америки.</p> ";
// Exports
export default code;